import {Injectable, isDevMode} from '@angular/core';
import {environment} from "@environments/environment";
import {HttpBackend, HttpClient, provideHttpClient} from "@angular/common/http";
import {provideTransloco, Translation, TranslocoLoader, TranslocoService} from "@jsverse/transloco";
import {catchError} from "rxjs/operators";
import { VERSION_BUILD } from "@environments/version.build";
import {CdnAssetResolverService} from "@core/services/cdn-asset-resolver.service";


/**
 * https://jsverse.github.io/transloco/docs/getting-started/installation
 *
 * Flow tai file dich:
 * 1. Neu CDN duoc bat (useTranslationCdn = true va isActiveDomainStatic):
 * -> Goi thang static CDN (vd: vpage2.static.nvncdn.com/assets/i18n/{lang}.json?v=2)
 * -> Neu loi (CDN 4xx/5xx / timeout): fallback ve server goc (vd: vpage.nhanh.vn/assets/language/{lang}.json)
 * 2. Neu CDN tat: doc file i18n truc tiep tu assets local.
 *
 * Dung HttpBackend thay vi HttpClient de BYPASS tat ca interceptor (Auth, Error, Loader).
 * Tranh tinh trang interceptor bien response thanh error -> kich hoat fallback ngoai y muon.
 * */
@Injectable({providedIn: 'root'})
export class TransLocoHttpLoader implements TranslocoLoader {
  /** HttpClient rieng, khong qua bat ky interceptor nao */
  private http: HttpClient;

  constructor(
    handler: HttpBackend,
    private cdnService: CdnAssetResolverService,
  ) {
    this.http = new HttpClient(handler);
  }

  public getTranslation(lang: string) {
    // Dev/local: doc file i18n trong project (link cu)
    const localFallbackUrl = environment.baseUrl + `assets/i18n/${lang}.json?v=${VERSION_BUILD.translate}`;

    if (this.isTranslationCdnEnabled()) {
      // CDN URL: https://vpage2.static.nvncdn.com/assets/i18n/{lang}.json?v=...
      const cdnUrl = this.cdnService.getCdnStaticUrl(`/assets/i18n/${lang}.json?v=${VERSION_BUILD.translate}`);
      // Fallback URL: https://vpage.nhanh.vn/assets/language/{lang}.json
      const fallbackUrl = this.cdnService.getAssetFallbackUrl(`/assets/language/${lang}.json`);

      return this.http.get<Translation>(cdnUrl).pipe(
        catchError(() => this.http.get<Translation>(fallbackUrl))
      );
    }

    return this.http.get<Translation>(localFallbackUrl);
  }

  /**
   * CDN translation chi duoc kich hoat khi ca useTranslationCdn va Worker deu san sang.
   */
  private isTranslationCdnEnabled(): boolean {
    const cf = environment.cloudFlareService;
    return !!(cf?.useTranslationCdn && this.cdnService.isCdnEnabled());
  }
}

export const TransLocoProviders: any[] = [
  TranslocoService,
  provideHttpClient(),
  provideTransloco({
    config: {
      availableLangs: environment.language.availableLangs,
      defaultLang: environment.language.code,
      reRenderOnLangChange: true,
      prodMode: !isDevMode(),
    },
    loader: TransLocoHttpLoader,
  }),
]

